export const workflowDetailsheaderConstants = {
  GET_REQUEST: "WORKFLOW_DETAILS_HEADER_GET_REQUEST",
  GET_SUCCESS: "WORKFLOW_DETAILS_HEADER_GET_SUCCESS",
  GET_FAILURE: "WORKFLOW_DETAILS_HEADER_GET_FAILURE",
  ARCHIVE_REQUEST: "WORKFLOW_DETAILS_HEADER_ARCHIVE_REQUEST",
  ARCHIVE_REQUEST_SUCCESS: "WORKFLOW_DETAILS_HEADER_ARCHIVE_REQUEST_SUCCESS",
  ARCHIVE_REQUEST_FAILURE: "WORKFLOW_DETAILS_HEADER_ARCHIVE_REQUEST_FAILURE"
};
